import { ContentWrapper } from "../../components/Wrappers/Wrappers"
import { DetailText, Title } from "../../components/units/Text"
import { useState, useEffect } from "react"
import { BoxWrapper, FlexWrapper } from "../../components/Wrappers/Wrappers"
import { hasPermission, useValidatePermission } from "../../roles/roles"
import { useSignedInContext } from "../../context/AuthContextProvider"
import { AxiosResponseProps, Params } from "../../components/Rest/RestStaffOrganization"
import { AxiosFetchOrganizationList } from "../../components/Rest/RestStaffOrganization"
import { SearchField } from "../../components/SearchFields/SearchFields"
import { OrganizationTable } from "../../components/Tables/OrganizationTable"
import { RestApiState } from "../../interfaces/Rest/types"


export const defaultParams = (): Params => {
    return {
        limit: 10,
        offset: 0,
        currentPage: 1,
        timeout: undefined,
        is_manufacture_date: undefined
    }
}


export const OrganizationList = () => {
    const { user } = useSignedInContext()
    useValidatePermission({ role : user.role, resource: 'Organization', action: 'list' })

    const [list, setList] = useState<AxiosResponseProps | undefined>(undefined)
    const [params, setParams] = useState<Params>(defaultParams())

    useEffect(() => {
        AxiosFetchOrganizationList(params, setList)
    }, [params.currentPage, params.ordering, params.is_manufacture_date])

    const useDeleteCallBack = (value: RestApiState) => {
        if (value === RestApiState.Success) {
            AxiosFetchOrganizationList(params, setList)
        }
    }

    useEffect(() => {
        const dropTimeout = ():void => {
            clearTimeout(params.timeout)
            setParams((prev) => ({
                ...prev, timeout : undefined
            }))

        }
        if (params.search === undefined) {
            return
        }
        if (params.timeout) {
            dropTimeout()
        } 
        const timeout = setTimeout(() => {
            AxiosFetchOrganizationList(params, setList)
            dropTimeout()
        }, 750) 
        setParams((prev) => ({
            ...prev, timeout : timeout
        }))
    }, [params.search])

    return (
        <ContentWrapper>
            <Title>Список Организаций</Title>
            <br />
            <BoxWrapper p="p0">
                <FlexWrapper justifyContent="space-between" alignItems="center">
                    { hasPermission({role: user.role, resource: 'Organization', action: "create"}) ? (
                        <DetailText href="/react/organization/create"
                            color="light"
                            bg="bg-secondary"
                            className="p1 flex align-center justify-center"
                            r="r15"
                            style={{height:'36px'}}
                        >Добавить организацию</DetailText>
                    ) : (
                        <BoxWrapper><></></BoxWrapper>
                    ) }
                    
                    <SearchField 
                        timeout={params.timeout} 
                        setSearch={(search:string):void => {
                            setParams((prev) => ({
                                ...prev, search : search
                            }))
                        }}/>
                </FlexWrapper>
            </BoxWrapper>
            <br />

            <OrganizationTable 
                data={list} 
                currentPage={params.currentPage} 
                itemsPerPage={params.limit}
                params={params}
                setter={(value: number) => {
                    setParams((prev) => ({
                        ...prev, currentPage: value
                    }))
                }}
                orderSetter={(value: string): void => {
                    setParams((prev) => ({
                        ...prev, ordering : value
                    }))}}
                deleteHook = {useDeleteCallBack}
                />
        </ContentWrapper>
        
    )
}